import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { ResetPasswordService } from '../../services/resetPassword/reset-password.service';

export const ResetPasswordResolver: ResolveFn<any> = (route, state) => {
  const token = route.queryParamMap.get("token")??"";
  return inject(ResetPasswordService).resetPasswordInit(token);
}
